// extracted by mini-css-extract-plugin
export default {"formItem":"TagSelectInput_formItem__M2Os-","spinnerContainer":"TagSelectInput_spinnerContainer__rjFnP","spinner":"TagSelectInput_spinner__deOiw"};